document.addEventListener("DOMContentLoaded", () => {
  AOS.init({
    duration: 1250,
    easing: "ease-out",
    once: true,
    offset: 200,
  });
});
